<template>
    <div v-show="states.visible" v-on:click.prevent="store.closeRequest" class="find-partner-box tw-z-50 tw-fixed tw-left-0 tw-top-0 tw-w-full tw-h-full tw-bg-black tw-bg-opacity-70 tw-overflow-auto">
        <div class="tw-mx-6" >
            <div style="height:38rem" class="tw-max-w-full md:tw-max-w-4xl tw-mx-auto tw-rounded tw-shadow-xl tw-my-16 tw-mx-16 tw-overflow-hidden tw-bg-white" v-on:click.stop>
                <register-confirm-close></register-confirm-close>
                <component :is="store.step()"/>
            </div>
        </div>
    </div>
</template>
<script>
    import store from "./register-store"
    import RegisterConfirmClose from './register-confirm-close'

    export default {
        components: {
            RegisterConfirmClose,
        },
        props:{
            isSocialRegister: {
                type: Boolean,
                default: false
            },
            showModal: {
                type: Boolean,
                default: false
            },
            socialData: {
                type: String,
                default: null
            }
        },
        data: v => ({
            states: store.states
        }),
        created() {
            this.store = store

            this.states.visible = this.showModal

            if (this.isSocialRegister) {
                this.states.isSocialRegister = this.isSocialRegister

                let socialData = JSON.parse(this.socialData)
                this.states.current_step = 2
                this.states.form.name = socialData.name
                this.states.form.email = socialData.email
                this.states.form.password = socialData.password
            }

            store.init()

            let documentClickCallback = ev => {
                if (ev.target !== this.$el && !this.$el.contains(ev.target)) {
                    if (this.states.is_open)
                        this.states.visible = true
                }
            }

            this.$on('hook:mounted', () => document.addEventListener('click', documentClickCallback))
            this.$on('hook:beforeDestroy', () => document.removeEventListener('click', documentClickCallback))
        },
        beforeDestroy() {
            store.destruct()
        }
    }
</script>
